<template>
  <div>
    <vs-prompt
      title="Select package to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add package"
      :is-valid="validForm"
      class="add-package-popup"
    >
      <div class="data-list-container data-list-list-view">
        <vs-table
          v-if="filteredPackages"
          ref="table"
          class="mt-8"
          pagination
          search
          maxItems="6"
          v-model="selectedPackage"
          :data="filteredPackages"
          noDataText="No data"
        >
          <template slot="thead">
            <vs-th sort-key="number">Identifier</vs-th>
            <vs-th sort-key="name">Name</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <div
                    class="product-name font-medium truncate flex flex-row items-center"
                  >
                    <img width="40" :src="ProductIcon" />
                    <p class="ml-4">{{ tr.id }}</p>
                  </div>
                </vs-td>
                <vs-td>
                  {{ tr.name }}
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      selectedPackage: null,
    };
  },
  emits: ["onSelected"],
  props: {
    alreadySelectedPackages: {
      type: Array,
      default: () => [],
    },
    selectablePackages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({}),
    validForm() {
      return this.selectedPackage != null;
    },

    // Filter out products already in the form
    filteredPackages() {
      if (!this.selectablePackages) {
        return [];
      }

      return this.selectablePackages.filter((e) => {
        return !this.alreadySelectedPackages.some((p) => p.id === e.id);
      });
    },
  },
  methods: {
    async show() {
      this.prompt = true;
    },
    async accept() {
      this.$emit("onSelected", this.selectedPackage);
    },
  },
};
</script>

<style lang="scss">
.add-package-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 900px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
